export enum BriefingBlockTypeApiEnum {
    TITLE = 'TITLE',
    TEXT = 'TEXT',
    IMAGE = 'IMAGE',
    DATE = 'DATE',
    CURATED_MENTION_LIST = 'CURATED_MENTION_LIST',
    AUTOMATIC_MENTION_LIST = 'AUTOMATIC_MENTION_LIST',
    ALERT_MENTIONS = 'ALERT_MENTIONS',
    SURGE_ALERT = 'SURGE_ALERT',
    TABLE_OF_CONTENT = 'TABLE_OF_CONTENT',
    LAYOUT = 'LAYOUT',
    ANALYSIS = 'ANALYSIS',
    DIVIDER = 'DIVIDER',
    LINK = 'SOCIAL_LINKS',
    CHART = 'CHART',
    COVERAGE_CURATOR = 'COVERAGE_CURATOR',
}
